import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import doc1 from "@assets/images/pdfIcon.svg";
import Doc from "@assets/images/mp3Icon.svg";
import Locked from "@assets/images/locked.svg";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import videoPlaceholder from "@assets/images/videoPlaceholder.png";
import videoPfrom from "@assets/images/videoIconP.png";
import VideoPreviewModal from "../VideoPreviewModal";
import ImagePreviewModal from "../ImagePreviewModal";
import YoutubeVideoPreviewModal from "../MediaBrowser/YoutubeVideoPreviewModal";

export default function Hotbar({
  images = [],
  videos = [],
  audios = [],
  documents = [],
}) {
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const attachmentStyle = {
    borderRadius: "8px",
    backgroundColor: "#F6F7F9",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    border: "2px solid #E1E1E1",
    marginLeft: "10px",
    flexWrap: "wrap",
    gap: "5px", // 'gap' property can be used to set spacing between grid items
    marginTop: "10px",
  };

  const tabStyle = {
    width: "25%",
  };

  const [openPreviewImage, setOpenPreviewImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpenPreviewImage = (src) => {
    setSelectedImage(src);
    setOpenPreviewImage(true);
  };

  const handleClosePreviewImage = () => {
    setOpenPreviewImage(false);
  };

  const pattern = /^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;

  const [openYoutubePreviewVideo, setOpenYoutubePreviewVideo] =
    React.useState(false);
  const [selectedYoutubeVideo, setSelectedYoutubeVideo] = React.useState(null);

  const handleOpenYoutubePreviewVideo = (src) => {
    setSelectedYoutubeVideo(src);
    setOpenYoutubePreviewVideo(true);
  };

  const handleClosePreviewYoutubeVideo = () => {
    setOpenYoutubePreviewVideo(false);
  };

  const renderImages = (segment) => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "5px", // 'gap' property can be used to set spacing between grid items
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {/* {Array.from({ length: 13 }, (_, index) => ( */}
          {images.map((e, index) => (
            <Box
              sx={{
                marginRight: "5px",
                cursor: "pointer",
                width: "90px",
                height: "80px",
                borderRadius: "5px",
                backgroundImage: `url(${e})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
              key={index}
              onClick={() => handleOpenPreviewImage(e)}
            >
              {/* <img
                alt="Alt of img"
                src={e}
                style={{
                  height: "80px",
                  width: "90px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              /> */}
            </Box>
          ))}
        </Box>
        <ImagePreviewModal
          openPreviewImage={openPreviewImage}
          handleClosePreviewImage={handleClosePreviewImage}
          selectedImage={selectedImage}
        />
      </>
    );
  };

  const renderAudios = (item) => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "5px", // 'gap' property can be used to set spacing between grid items
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {audios.map((e, index) => (
            <Box sx={attachmentStyle}>
              <img
                alt="Alt of img"
                src={Doc}
                style={{ width: "35", height: "35px" }}
              />
              <Box
                style={{
                  backgroundColor: "#123051",
                  borderRadius: "20px",
                  marginTop: "5px",
                  width: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "5px",
                  cursor: "pointer",
                }}
              >
                <Typography
                  style={{
                    color: "white",
                    fontSize: "8px",
                  }}
                  onClick={() => window.open(e, "_blank")}
                >
                  Play
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </>
    );
  };

  const renderAttachmentItem = (item) => {
    return (
      <>
        <Box
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "5px", // 'gap' property can be used to set spacing between grid items
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {/* {Array.from({ length: 13 }, (_, index) => ( */}
          {documents.map((e, index) => (
            <Box style={attachmentStyle}>
              <img
                alt="Alt of img"
                src={doc1}
                style={{ width: "35px", height: "35px" }}
              />
              <Box
                style={{
                  backgroundColor: "#123051",
                  borderRadius: "20px",
                  marginTop: "5px",
                  width: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "5px",
                  cursor: "pointer",
                }}
              >
                <Typography
                  style={{
                    color: "white",
                    fontSize: "8px",
                  }}
                  onClick={() => window.open(e, "_blank")}
                >
                  Open
                </Typography>
                {/* {index % 2 ? (
                  <img
                    alt="Alt of img"
                    src={Locked}
                    style={{ height: "15px", width: "15px" }}
                  />
                ) : (
                  <Typography
                    style={{
                      color: "white",
                      fontSize: "8px",
                    }}
                    onClick={() => window.open(e, "_blank")}
                  >
                    Open
                  </Typography>
                )} */}
              </Box>
            </Box>
          ))}
        </Box>
      </>
    );
  };

  const [openPreviewVideo, setOpenPreviewVideo] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleOpenPreviewVideo = (src) => {
    setSelectedVideo(src);
    setOpenPreviewVideo(true);
  };

  const handleClosePreviewVideo = () => {
    setOpenPreviewVideo(false);
  };

  function getYoutubeThumbnailUrl(videoUrl) {
    // Extract the video ID from the YouTube URL
    const videoIdMatch = videoUrl.match(
      /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([^\s&]+)/
    );
    if (videoIdMatch) {
      const videoId = videoIdMatch[1];
      // Construct the thumbnail URL
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    } else {
      return null; // Return null if the video ID couldn't be extracted
    }
  }

  const renderVideos = (segment) => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "5px", // 'gap' property can be used to set spacing between grid items
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {/* {Array.from({ length: 7 }, (_, index) => ( */}
          {videos.map((e, index) => (
            <div
              style={{
                position: "relative",
                overflow: "hidden",
                width: "140px",
                height: "80px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={() => {
                pattern.test(e)
                  ? handleOpenYoutubePreviewVideo(e)
                  : handleOpenPreviewVideo(e);
              }}
            >
              {pattern.test(e) ? (
                <img
                  src={getYoutubeThumbnailUrl(e)}
                  alt="ytVideo"
                  style={{
                    width: "140px",
                    height: "80px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <video
                  width="140"
                  height="80"
                  preload="metadata"
                  style={{ objectFit: "cover" }}
                >
                  <source src={e} type="video/mp4" />
                </video>
              )}
            </div>
          ))}
        </Box>
        <VideoPreviewModal
          openPreviewVideo={openPreviewVideo}
          handleClosePreviewVideo={handleClosePreviewVideo}
          videoUrl={selectedVideo}
        />

        <YoutubeVideoPreviewModal
          openPreviewVideo={openYoutubePreviewVideo}
          handleClosePreviewVideo={handleClosePreviewYoutubeVideo}
          videoUrl={selectedYoutubeVideo}
        />
        {/* <Modal
          open={openPreviewVideo}
          onClose={handleClosePreviewVideo}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "65vw",
              height: "85vh",
              bgcolor: "background.paper",
              boxShadow: 24,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "black",
                padding: "10px",
              }}
            >
              <KeyboardBackspaceIcon
                style={{ color: "white", cursor: "pointer" }}
                onClick={handleClosePreviewVideo}
              />
              <CloseIcon
                style={{ color: "white", cursor: "pointer" }}
                onClick={handleClosePreviewVideo}
              />
            </div>
            <video
              src={sampleVideo}
              alt="Selected"
              style={{ width: "100%", height: "100%" }}
              controls
              autoPlay
            />
          </Box>
        </Modal> */}
      </>
    );
  };

  const [tabvalue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "65vw",
            height: "85vh",
            bgcolor: "background.paper",
            boxShadow: 2,
            borderRadius: "20px",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="h6"
              component="h6"
              style={{
                fontFamily: "DM Sans",
                fontWeight: "bold",
                marginLeft: "5px",
                margin: "15px",
                marginLeft: "30px",
              }}
            >
              Hotbar Gallery
            </Typography>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabvalue}
                onChange={handleTabChange}
                aria-label="basic tabs example"
              >
                <Tab sx={tabStyle} label="Images" {...a11yProps(0)} />
                <Tab sx={tabStyle} label="Videos" {...a11yProps(1)} />
                <Tab sx={tabStyle} label="Audios" {...a11yProps(2)} />
                <Tab sx={tabStyle} label="Attachments" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={tabvalue} index={0}>
              {/* {[1, 2].map((e) => renderImages())} */}
              {renderImages()}
            </CustomTabPanel>
            <CustomTabPanel value={tabvalue} index={1}>
              {renderVideos()}
              {/* {[1, 2].map((e) => renderVideos())} */}
            </CustomTabPanel>
            <CustomTabPanel value={tabvalue} index={2}>
              {renderAudios()}
              {/* {[1, 2].map((e) => renderAudios())} */}
            </CustomTabPanel>
            <CustomTabPanel value={tabvalue} index={3}>
              {renderAttachmentItem()}
              {/* {[1, 2].map((e) => renderAttachmentItem())} */}
            </CustomTabPanel>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
